(function () {
  // Localised markets prefix every path, so a literal /products/ 404s there.
  var RV_ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var KEY = 'kisa_recently_viewed';
  var MAX_STORED = 20;

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return [];
      var arr = JSON.parse(raw);
      return Array.isArray(arr) ? arr : [];
    } catch (e) { return []; }
  }

  function write(arr) {
    try { localStorage.setItem(KEY, JSON.stringify(arr.slice(0, MAX_STORED))); } catch (e) {}
  }

  function push(handle) {
    if (!handle) return;
    var list = read().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    write(list);
  }

  function money(cents, format) {
    var amount = (cents / 100).toFixed(2);
    return (format || '$') + amount;
  }

  // Mirrors snippets/sale-badge-text.liquid. The cards are built here rather
  // than in Liquid, so the same wording has to be worked out a second time.
  function formatMoney(cents, format) {
    var f = format || '${{amount}}';
    var value = cents / 100;
    return f
      .replace(/\{\{\s*amount\s*\}\}/, value.toFixed(2))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(value))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.toFixed(2).replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, String(Math.round(value)))
      .replace(/\{\{\s*amount_with_period_and_space_separator\s*\}\}/, value.toFixed(2));
  }

  function badgeText(price, compare, opts) {
    var percent = compare > 0 ? Math.round(((compare - price) / compare) * 100) : 0;
    var amount = formatMoney(compare - price, opts.moneyFormat);
    var save = opts.badgeSaveWord || 'Save';
    switch (opts.badgeMode) {
      case 'percent_minus': return '-' + percent + '%';
      case 'percent': return percent + '%';
      case 'percent_save': return save + ' ' + percent + '%';
      case 'amount': return amount;
      case 'amount_minus': return '-' + amount;
      case 'amount_save': return save + ' ' + amount;
      case 'custom':
        return (opts.badgeCustomText || 'Sale')
          .replace('[percent]', percent)
          .replace('[amount]', amount);
      default: return opts.badgeSaleWord || 'Sale';
    }
  }

  function renderCard(product, opts) {
    var img = product.featured_image || (product.images && product.images[0]) || '';
    var price = product.price;
    var compare = product.compare_at_price;
    var fmt = (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
    var priceHtml;
    if (compare && compare > price) {
      priceHtml = '<s>' + money(compare) + '</s>' + money(price);
    } else {
      priceHtml = money(price);
    }
    var titleStyle = '';
    if (opts.titleColor) titleStyle += 'color:' + opts.titleColor + ';';
    var badge = '';
    if (compare && compare > price) {
      badge = '<div class="card__badge rv-card__badge"><span class="badge">' + badgeText(price, compare, opts) + '</span></div>';
    }
    return '<a href="' + RV_ROOT + 'products/' + product.handle + '" class="rv-card">' +
      '<div class="rv-card__media">' + badge + '<img src="' + img + '" alt="' + (product.title || '').replace(/"/g, '&quot;') + '" loading="lazy"></div>' +
      '<div class="rv-card__info">' +
        '<div class="rv-card__title">' + product.title + '</div>' +
        '<div class="rv-card__price">' + priceHtml + '</div>' +
      '</div>' +
    '</a>';
  }

  function init(container) {
    var current = container.dataset.currentHandle;
    if (current) push(current);

    var isMobile = window.matchMedia('(max-width: 749px)').matches;
    var limit = parseInt(isMobile ? container.dataset.limitMobile : container.dataset.limitDesktop, 10) || 4;
    var handles = read().filter(function (h) { return h !== current; }).slice(0, limit);

    var grid = container.querySelector('[data-rv-grid]');
    var empty = container.querySelector('[data-rv-empty]');

    if (handles.length === 0) {
      if (container.dataset.emptyBehavior === 'cta' && empty) {
        container.hidden = false;
        if (grid) grid.style.display = 'none';
        empty.hidden = false;
      }
      return;
    }

    Promise.all(handles.map(function (h) {
      return fetch(RV_ROOT + 'products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (products) {
      var html = products.filter(Boolean).map(function (p) { return renderCard(p, container.dataset); }).join('');
      if (!html) return;
      grid.innerHTML = html;
      container.hidden = false;
      wireArrows(container, grid);
    });
  }

  // Scrolls by whatever is currently in view rather than a fixed figure, so it
  // keeps up with the per view setting and with the jump to mobile.
  function wireArrows(container, grid) {
    var prev = container.querySelector('[data-rv-prev]');
    var next = container.querySelector('[data-rv-next]');
    if (!prev || !next) return;
    function page(dir) {
      grid.scrollBy({ left: dir * grid.clientWidth, behavior: 'smooth' });
    }
    function update() {
      var max = grid.scrollWidth - grid.clientWidth - 1;
      prev.hidden = grid.scrollLeft <= 0;
      next.hidden = grid.scrollLeft >= max;
    }
    prev.addEventListener('click', function () { page(-1); });
    next.addEventListener('click', function () { page(1); });
    grid.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function boot() {
    document.querySelectorAll('[data-recently-viewed]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
